import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { TutorialTooltipReducer } from '@adc/ui-adc'
import user from './user'
import listing from './listing'
import modals from './modals'
import propertyAnalytics from './propertyAnalytics'
import featureFlags from './featureFlags'
import suggestedOffer from './suggestedOffer'
import app from './app'

export default combineReducers({
  user,
  listing,
  modals,
  form: formReducer,
  tutorial: TutorialTooltipReducer,
  featureFlags,
  propertyAnalytics,
  suggestedOffer,
  app,
})
